import { useAnimate } from "react-simple-animate";
import SidebarLinks from "./SidebarLinks";
import Sidebar from "../components/Sidebar";
import Navbar from "../components/Navbar";
import HeaderLink from "./HeaderLink";
import '../common/styles/adminDashboard.css'
import Dashboard from "../components/Dashboard";
import { Route, Routes } from "react-router-dom";
import { NavigationRoutes } from "../../constant/Routes";
import UserLisitingTable from "./user-component/UserLisitingTable";
import PlansListingTable from "../../features/plans/PlansListingTable";

import UserDetail from "./user-component/UserDetails";
import CategoriesListing from "./../../features/category/categories";
import AttributesListing from "./../../features/category/attributes";
import VehiclesListingTable from "../../features/vehicles/VehiclesListingTable";

import ContactUsListingTable from "../../features/contact-us/ContactUsListingTable";
import AdReportListingTable from "../../features/ad-reports/AdReportListingTable";


import MakeListing from "../../features/make/make";
import AddBlog from "../../features/blog/AddBlog";

import BlogListingTable from "../../features/blog/Blogs";

import SettingsListingTable from "../../features/settings/SettingsListingTable";

import FaqsListingTable from "../../features/faqs/FaqsListingTable";

function AdminDashboard() {

    const { play, style, isPlaying } = useAnimate({
        start: {
            width: "301px",
            minWidth: "300px",
        },
        end: {
            width: "95px",
            minWidth: "95px",
        },
    });
    return (<div className="main_container_dashboard">

        <div className="side_bar_content" style={style}>
            <Sidebar play={play} isPlaying={isPlaying} Options={SidebarLinks} />
        </div>
        <div className="header_table" style={{width:style.width=="95px"?"calc(100% - 95px)":"calc(100% - 300px)"}}>





<div className="header_dashboard">
                <Navbar Options={HeaderLink} />
            </div>
            <div className="table_dashboard">
            <Routes>
            <Route path="" element={<Dashboard />} />
            <Route path={NavigationRoutes.VERIFIED_USER_LISTING} element={<UserLisitingTable />} />
            <Route path={NavigationRoutes.CATEGORIES} element={<CategoriesListing />} />
            <Route path={NavigationRoutes.SUB_CATEGORIES} element={<CategoriesListing />} />
            <Route path={NavigationRoutes.ATTRIBUTES} element={<AttributesListing />} />

            <Route path={NavigationRoutes.PLANS} element={<PlansListingTable />} />
            <Route path={NavigationRoutes.VEHICLE} element={<VehiclesListingTable />} />
            <Route path={NavigationRoutes.VEHICLE_MAKE} element={<MakeListing />} />
            <Route path={NavigationRoutes.VEHICLE_MODEL} element={<MakeListing />} />

            <Route path={NavigationRoutes.HEADERSETTINGS} element={<SettingsListingTable />} />

            <Route path={NavigationRoutes.ADD_BLOG} element={<AddBlog />} />
            <Route path={NavigationRoutes.EDIT_BLOG} element={<AddBlog />} />

            <Route path={NavigationRoutes.BLOG} element={<BlogListingTable />} />
            <Route path={NavigationRoutes.FAQS} element={<FaqsListingTable />} />
                    <Route path={NavigationRoutes.CONTACTUS} element={<ContactUsListingTable />} />

                    <Route path={NavigationRoutes.ADREPORTS} element={<AdReportListingTable />} />

            <Route path={NavigationRoutes.USER_DETAILS} element={<UserDetail />} />
            <Route path="*" element={<Dashboard />} />
            </Routes>
        </div>
        </div>
    </div>);
}

export default AdminDashboard;